import React, { useState } from 'react'

import { Modal } from 'antd'
import { Toolbar } from 'primereact/toolbar'

import AddNewButton from '../../components/CustomButtons/addNewButton'
import ExportButton from '../../components/CustomButtons/exportGreenButton'
import GlobalSearchInput from '../../components/CustomGlobalSearchInput/globalSearchInput'
import { getMessage } from '../../util/IntlMessages'
import CreateAlternative from './CreateAlternative/CreateAlternative'

const Header = ({ globalFilterValue, onGlobalFilterChange, exportCSV, exportExcelData, updateAlternativeList }) => {
  const [modalDocumentVisible, setModalDocumentVisible] = useState(false)
  return (
    <Toolbar
      start={
        <div>
          <h2>
            <b>Lista de Alternativos</b>
          </h2>
        </div>
      }
      end={
        <React.Fragment>
          <div className="container-header-lists">
            <GlobalSearchInput value={globalFilterValue} onChange={onGlobalFilterChange} />

            <div>
              <ExportButton iconType="csv" label={getMessage('label.exportCvs')} onClick={() => exportCSV(false)} />
              <ExportButton iconType="excel" label={getMessage('label.exportXls')} onClick={exportExcelData} />
              <AddNewButton label={getMessage('createAlternatives')} onClick={() => setModalDocumentVisible(true)} />
            </div>
          </div>

          <Modal
            destroyOnClose={() => setModalDocumentVisible(false)}
            onCancel={() => setModalDocumentVisible(false)}
            title={getMessage('createAlternate')}
            footer={null}
            width="70%"
            visible={modalDocumentVisible}
          >
            <CreateAlternative
              alternativeId={null}
              onCancel={() => setModalDocumentVisible(false)}
              updateAlternativeList={updateAlternativeList}
            />
          </Modal>
        </React.Fragment>
      }
    />
  )
}

export default Header
